import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';

export type ColorConfigJson = {
  light: string;
  dark: string;
};

export class ColorConfig implements JsonConfigInterface<ColorConfigJson> {

  private _light: string = '#000';
  private _dark: string = '#000';

  constructor(json?: ColorConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get light(): string {
    return this._light;
  }

  public get dark(): string {
    return this._dark;
  }

  public deserializeJson(json: ColorConfigJson): void {
    this._light = json.light;
    this._dark = json.dark;
  }

  public fromTheme(darkTheme: boolean): string {
    return darkTheme ? this._dark : this._light;
  }
}
